module.exports = __webpack_public_path__ + "static/flags/PL-ebbc55bcaf867ed2cf96f08f56f61252.gif";